import { BoxProps, useMediaQuery, useTheme } from '@material-ui/core'
import { FlexCol, FlexGrowRow, FlexRow } from '@xyo-network/sdk-xyo-react-js'
import React from 'react'

import { SigninAccountBox, WhatIsCoin } from '../../../Components'
import logo from '../img/logo-full.svg'

const CreateAccount: React.FC<BoxProps> = (props) => {
  const { ...boxProps } = props
  const theme = useTheme()
  const logoSize = useMediaQuery(theme.breakpoints.up('md')) ? 64 : 48
  return (
    <FlexCol flexGrow={1} flexBasis={50} alignItems="stretch" padding={2} {...boxProps}>
      <FlexRow justifyContent="flex-start" margin={1} marginY={3}>
        <img src={logo} title="COIN Logo" height={logoSize} />
      </FlexRow>
      <SigninAccountBox title="Sign In" marginY={2} maxWidth={600} />
      <FlexGrowRow />
      <WhatIsCoin />
    </FlexCol>
  )
}

export default CreateAccount
